import './header.css';
import '../../../index.css';

import Title from '../Title/index';

import '../../../index.css';

const Header = () => {
  return (
    <header id="header" className="header">
      <div className="header__list-slogon">
        <Title level="2" size="bg">
          Проектирование, монтаж, поставка электрощитового оборудования
        </Title>
      </div>
      <div className="header__button">
        <button className="header__buttonCall" value="Позвонить нам">
          <a href="tel:+7(952)200-83-34">Позвонить нам</a>
        </button>
      </div>
    </header>
  );
};
export default Header;
